import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidemenu from "../base/sidemenu";
import "./DeviceDetailRedesign.css";

export default function DeviceDetailRedesign() {
  const location = useLocation();
  const navigate = useNavigate();
  const device = location.state?.device || {};

  const handleGoBack = () => navigate(-1);

  const displayId = (value) =>
    String(value ?? "-").replace(/^DAWONDNS-B350N_NBX-\s*/, "");

  const installed = device.is_matched === 1;

  const statusLabel = (status) => {
    if (status === 1) return "정상";
    if (status === 0) return "비정상";
    return "정보 없음";
  };

  return (
    <div className="flex device-detail-redesign-layout">
      <Sidemenu />

      <main className="device-detail-redesign-content">
        <div className="dd-page">
          <div className="dd-top">
            <button className="dd-back" onClick={handleGoBack}>
              ← 장비 목록
            </button>
          </div>

          <div className="dd-heading">
            <h2>장비 상세정보</h2>
            <p>장비의 설치 정보와 현재 상태를 확인할 수 있습니다.</p>
          </div>

          
          <div className="dd-overview">
            <section className="dd-card dd-user-card">
              <div className="dd-card-title">
                <h3>사용자 기본 정보</h3>
                <span className="dd-card-subtitle">
                  장비가 연결된 사용자 및 설치 정보
                </span>
              </div>

              <div className="dd-user-info">
                <div>
                  <span>사용자 이름</span>
                  <strong>{device.name || "-"}</strong>
                </div>
                <div>
                  <span>연락처</span>
                  <strong>{device.phone || "-"}</strong>
                </div>
                <div>
                  <span>설치 여부</span>
                  <strong>
                    <span className={`dd-badge ${installed ? "installed" : "not-installed"}`}>
                      {installed ? "설치됨" : "설치안됨"}
                    </span>
                  </strong>
                </div>
                <div>
                  <span>설치 위치</span>
                  <strong>  
	  		{[device.address, device.detail_address]
			    .filter(Boolean)
			    .join(' ') || '-'}
		  </strong>
                </div>
              </div>
            </section>

            <div className="dd-device-grid">
              <section className="dd-card dd-device-card">
                <div className="dd-card-title">
                  <h3>플러그</h3>
                  <span className="dd-card-subtitle">스마트 플러그 정보</span>
                </div>

                <div className="dd-device-field">
                  <span>장비 ID</span>
                  <div className="dd-device-id-box">
                    <code className="dd-device-id">{device.plug_id || "-"}</code>
                    {device.plug_id && (
                      <button
                        type="button"
                        className="dd-copy"
                        onClick={() => navigator.clipboard.writeText(device.plug_id)}
                        title="플러그 ID 복사"
                      >
                        복사
                      </button>
                    )}
                  </div>
                </div>

                <div className="dd-device-field">
                  <span>장비 상태</span>
                  <div>
                    <span className={`dd-badge ${device.plug_status === 1 ? "normal" : device.plug_status === 0 ? "abnormal" : "unknown"}`}>
                      {statusLabel(device.plug_status)}
                    </span>
                  </div>
                </div>
                <div className="dd-device-field">
                  <span>마지막 전력 수신</span>
                  <div>
                    <strong>{device.last_power_received || "수신 기록 없음"}</strong>
                  </div>
                </div>
              </section>

              <section className="dd-card dd-device-card">
                <div className="dd-card-title">
                  <h3>스위치</h3>
                  <span className="dd-card-subtitle">스마트 스위치 정보</span>
                </div>

                <div className="dd-device-field">
                  <span>장비 ID</span>
                  <div className="dd-device-id-box">
                    <code className="dd-device-id">{device.swich_id || "-"}</code>
                    {device.swich_id && (
                      <button
                        type="button"
                        className="dd-copy"
                        onClick={() => navigator.clipboard.writeText(device.swich_id)}
                        title="스위치 ID 복사"
                      >
                        복사
                      </button>
                    )}
                  </div>
                </div>

                <div className="dd-device-field">
                  <span>장비 상태</span>
                  <div>
                    <span className={`dd-badge ${device.swich_status === 1 ? "normal" : device.swich_status === 0 ? "abnormal" : "unknown"}`}>
                      {statusLabel(device.swich_status)}
                    </span>
                  </div>
                </div>
                <div className="dd-device-field">
                  <span>마지막 스위치 조작</span>
                  <div>
                    <strong>{device.last_switch_action || "조작 기록 없음"}</strong>
                  </div>
                </div>
              </section>
	
	      <section className="dd-card dd-device-card">
  <div className="dd-card-title">
    <h3>감지기</h3>
    <span className="dd-card-subtitle">재실 감지기 정보</span>
  </div>

  <div className="dd-device-field">
    <span>장비 ID</span>
    <div className="dd-device-id-box">
      <code className="dd-device-id">
        {device.motion_id || "미설치"}
      </code>
    </div>
  </div>

  <div className="dd-device-field">
    <span>장비 상태</span>
    <div>
      {device.motion_id ? (
        <span
          className={`dd-badge ${
            Number(device.motion_status) === 1
              ? "normal"
              : Number(device.motion_status) === 0
                ? "abnormal"
                : "unknown"
          }`}
        >
          {statusLabel(device.motion_status)}
        </span>
      ) : (
        <span className="dd-badge unknown">미설치</span>
      )}
    </div>
  </div>

  <div className="dd-device-field">
    <span>최근 모션 이벤트</span>
    <div>
      <strong>
        {device.motion_id
          ? device.last_motion_action || "이벤트 기록 없음"
          : "-"}
      </strong>
    </div>
  </div>
</section>

            </div>

            <section className="dd-card dd-response-card">
              <span>장비 정보 최종 갱신</span>
              <strong>{device.create_date || "-"}</strong>
            </section>
          </div>


          <div className="dd-actions">
            {!device.address && (
              <button
                className="dd-primary"
                onClick={() => navigate("/device/new", { state: { device } })}
              >
                사용자 등록
              </button>
            )}
            <button className="dd-secondary" onClick={handleGoBack}>
              확인 · 목록으로
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
